/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component } from 'react';
import { Button, ButtonToolbar, Picker } from './uiold';
import { View, StyleSheet } from 'react-native';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import autobind from 'class-autobind';

import { showSuccess } from '../components/App/AppAlert';
import IndexedList from '../support/shared/IndexedList';
import PlacementActions from '../support/PlacementActions';
import LoadingIndicator from './uiold/LoadingIndicator';
import { VendorPlacementList } from './PlacementEditor/VendorPlacementList';
import { VendorSelectModal } from './PlacementEditor/VendorSelectModal';
import DataStore from '../support/DataStore';
import connectData, { ConnectedProps } from '../support/connectData';
import getVendorPlacement from '../support/helpers/getVendorPlacement';
import toElement from '../support/helpers/toElement';
import {
  KEY_BACKSPACE,
  KEY_ENTER,
  KEY_ESCAPE,
  KEY_SPACE,
  KEY_UP_ARROW,
  KEY_DOWN_ARROW,
  KEY_DELETE,
} from '../support/KeyCodes';

import { Market } from '../types/shared/Market';
import { VendorList, VendorSummaryWithMarkets } from '../types/shared/Vendor';
import formatDate from '../core/support/formatDate';

const dataStore = DataStore.getInstance('app');

type State = {
  activeMarketID: string | null | undefined;
  activeDate: string | null | undefined;
  focusedIndex: number;
  selectedIndex: number | null;
  selectedIndexes: Set<number>;
  selectedCursor: number;
};

class PlacementEditorLegacy extends Component<FullProps, State> {
  constructor(props: FullProps) {
    super(props);
    autobind(this);
    this.state = {
      activeMarketID: null,
      activeDate: null,
      focusedIndex: 0,
      selectedIndex: null,
      selectedIndexes: new Set(),
      selectedCursor: 0,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this._documentKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._documentKeyDown);
  }

  render() {
    let { markets, filteredMarkets, vendors, placement } = this.props;
    let { selectedIndexes } = this.state;
    if (!markets || !vendors || !placement || !filteredMarkets) {
      return (
        <div className="main-col portlet">
          <LoadingIndicator />
        </div>
      );
    }
    if (markets.length === 0) {
      return (
        <div className="main-col portlet">
          <p>
            You have no markets. <Link to="/markets">Click Here</Link> to add a
            market.
          </p>
        </div>
      );
    }
    let { activeMarket } = this._getActive();
    if (!activeMarket) {
      return (
        <div className="main-col portlet">
          <p>
            {`You don't have any market dates. `}
            <Link to="/markets">Click Here</Link> to edit your markets.
          </p>
        </div>
      );
    }

    return (
      <div className="main-col portlet placement-editor">
        <h2>Placement</h2>
        <View style={{ flexDirection: 'column' }}>
          <View style={styles.pickerContainer}>
            <Picker
              options={filteredMarkets.getList()}
              selectedItem={activeMarket}
              onChange={this._onMarketSelect}
              maxWidth={360}
              style={{ marginRight: 10 }}
            />
            {this._renderDateSelector()}
            {this._renderCopySelector()}
            {this._renderButtonToolbar()}
          </View>
          <View style={{ zIndex: selectedIndexes.size > 0 ? 3 : 0 }}>
            {this._renderSpots()}
            {this._renderModal()}
          </View>
        </View>
      </div>
    );
  }

  _renderDateSelector() {
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket) {
      return;
    }
    let activeMarketDate;
    activeMarket.dates.forEach((date) => {
      let marketDate = {
        id: date,
        name: formatDate(date, { fromUTC: true, includeDayOfWeek: true }),
      };
      if (date === activeDate) {
        activeMarketDate = marketDate;
      }
    });
    let options = activeMarket.dates.map((date) => {
      return {
        id: date,
        name: formatDate(date, { fromUTC: true, includeDayOfWeek: true }),
      };
    });
    return (
      <Picker
        options={options}
        selectedItem={activeMarketDate}
        onChange={this._onDateSelect}
        style={{ marginRight: 10 }}
      />
    );
  }

  _renderCopySelector() {
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }
    if (activeMarket.dates.length < 2) {
      return;
    }
    let options = [{ id: '0', name: t('Copy to') }];
    activeMarket.dates.forEach((date) => {
      if (date !== activeDate) {
        options.push({
          id: date,
          name: formatDate(date, { fromUTC: true, includeDayOfWeek: true }),
        });
      }
    });
    return (
      <Picker
        options={options}
        selectedItem={options[0]}
        onChange={this._onCopyDateSelect}
      />
    );
  }

  _renderButtonToolbar() {
    if (!this.props.isDirty) {
      return null;
    }
    if (this.props.isSaving) {
      return (
        <div className="pull-right">
          <LoadingIndicator />
        </div>
      );
    }
    return (
      <ButtonToolbar>
        <Button
          onPress={this.props.fetchAll}
          title="Revert"
          style={{ marginLeft: 10, marginRight: 0 }}
        />
        <Button
          onPress={this._onSave}
          title="Save"
          isPrimary
          style={{ marginLeft: 10 }}
        />
      </ButtonToolbar>
    );
  }

  _renderSpots() {
    let { vendors, placement } = this.props;
    let { activeMarket, activeDate } = this._getActive();

    if (!activeMarket || !activeDate) {
      return;
    }
    let numSpots = activeMarket.num_spots || 0;
    if (numSpots === 0) {
      return (
        <p>
          {`This market has no spots. Go to "Markets & Dates" tab to specify the number of spots for this market.`}
        </p>
      );
    }
    let placementByIndex = getVendorPlacement(activeMarket, activeDate, {
      vendors,
      placement,
    });
    return (
      <div tabIndex={0} className="vendor-spots">
        <VendorPlacementList
          numSpots={activeMarket.num_spots || 0}
          onClick={(index) => {
            this.setState({ selectedIndex: index });
          }}
          vendorPlacement={placementByIndex}
        />
      </div>
    );
  }

  _getStallNames = () => {
    let { positionMap } = this.props;
    let market = this._getActiveMarket();
    let { activeMarket } = this._getActive();
    if (!activeMarket || !market || !positionMap) {
      return;
    }
    let numSpots = activeMarket.num_spots;

    let defaultPositionName: ObjectOf<string> = {};
    for (let index = 0; index < numSpots; index++) {
      defaultPositionName[index] = String(index + 1);
    }

    let activeMarketPositionMap = positionMap[market.id] || {};

    return {
      ...defaultPositionName,
      ...activeMarketPositionMap,
    };
  };

  _getActiveMarket(): Market | null | undefined {
    let { activeMarketID } = this.state;
    let markets = this.props.filteredMarkets;
    if (!markets) {
      return;
    }
    return (
      (activeMarketID && markets.getByID(activeMarketID)) ||
      markets.getByIndex(0)
    );
  }

  _renderModal() {
    let { selectedIndex } = this.state;
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }
    let placedVendors = this._getPlacedVendors(activeMarket, activeDate);
    let eligibleVendors =
      this._getEligibleVendors(activeMarket, activeDate)?.getList() ?? [];

    return (
      <VendorSelectModal
        isOpen={selectedIndex != null}
        onClick={(vendor) => {
          this._onVendorSelect(vendor);
        }}
        onClose={() => {
          this.setState({ selectedIndex: null });
        }}
        placedVendors={placedVendors}
        vendors={eligibleVendors}
      />
    );
  }

  _getScrollContainer() {
    return document.body;
  }

  _getActive(): {
    activeMarket: Market | null | undefined;
    activeDate: string | null | undefined;
  } {
    let { activeMarketID, activeDate } = this.state;
    let markets = this.props.filteredMarkets || new IndexedList([]);
    let activeMarket =
      (activeMarketID && markets.getByID(activeMarketID)) ||
      markets.getByIndex(0);
    if (activeMarket) {
      activeDate =
        activeDate != null && activeMarket.dates.indexOf(activeDate) !== -1
          ? activeDate
          : activeMarket.dates[0];
    } else {
      activeDate = null;
    }
    return { activeMarket, activeDate };
  }

  // get all vendors that are signed up for a given market date
  _getEligibleVendors(
    activeMarket: Market,
    activeDate: string,
  ): VendorList | null | undefined {
    let { sortedVendors } = this.props;
    if (!sortedVendors) {
      return;
    }
    return sortedVendors.filter((vendor) => {
      let markets = vendor.markets || {};
      let dates = markets[activeMarket.id];
      return dates ? dates.indexOf(activeDate) !== -1 : false;
    });
  }

  _getPlacedVendors(activeMarket: Market, activeDate: string) {
    let vendorsByID: ObjectOf<boolean> = {};
    let { placement } = this.props;
    if (!placement) {
      return vendorsByID;
    }
    for (let vendorID of Object.keys(placement)) {
      let vendorMarkets = placement[vendorID] || {};
      let vendorDates = vendorMarkets[activeMarket.id] || {};
      let placementIndexes = vendorDates[activeDate] || [];
      if (placementIndexes.length) {
        vendorsByID[vendorID] = true;
      }
    }
    return vendorsByID;
  }

  _onSave() {
    this.props.savePlacement();
  }

  _onSpotHover(event: Event, index: number) {
    this.setState({
      focusedIndex: index,
    });
  }

  _stallNameValues() {
    let stallNameObj = this._getStallNames();
    return stallNameObj ? Object.values(stallNameObj) : [];
  }

  _onVendorSelect(newVendor: VendorSummaryWithMarkets | null | undefined) {
    let { vendors, placement } = this.props;
    let { selectedIndex } = this.state;
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }
    let placementByIndex = getVendorPlacement(activeMarket, activeDate, {
      vendors,
      placement,
    });
    let existingVendor =
      selectedIndex != null ? placementByIndex[String(selectedIndex)] : null;
    this._hideVendorList();
    if (selectedIndex == null || newVendor === existingVendor) {
      return;
    }
    if (existingVendor) {
      PlacementActions.removeVendorPlacement(
        activeMarket,
        activeDate,
        selectedIndex,
        existingVendor,
      );
    }
    if (newVendor) {
      PlacementActions.addVendorPlacement(
        activeMarket,
        activeDate,
        selectedIndex,
        newVendor,
      );
    }
  }

  _hideVendorList() {
    this.setState({ selectedIndexes: new Set(), selectedCursor: 0 });
  }

  _onMarketSelect(market: Market) {
    this.setState({
      activeMarketID: market.id,
      activeDate: market.dates[0],
    });
  }

  _onDateSelect(date: { id: string }) {
    this.setState({ activeDate: date.id });
  }

  _onCopyDateSelect(dstDate: { id: string }) {
    let { vendors, placement } = this.props;
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }
    let srcPlacements = getVendorPlacement(activeMarket, activeDate, {
      vendors,
      placement,
    });
    let dstPlacements = getVendorPlacement(activeMarket, dstDate.id, {
      vendors,
      placement,
    });

    for (let [numIndex, vendor] of Object.entries(dstPlacements)) {
      let vendorToRemove = vendor;
      PlacementActions.removeVendorPlacement(
        activeMarket,
        dstDate.id,
        Number(numIndex),
        vendorToRemove,
      );
    }

    for (let [numIndex, vendor] of Object.entries(srcPlacements)) {
      let vendorToAdd = vendor;
      PlacementActions.addVendorPlacement(
        activeMarket,
        dstDate.id,
        Number(numIndex),
        vendorToAdd,
      );
    }

    if (placement === dataStore.get('placement')) {
      showSuccess('No changes to copy.');
    } else {
      showSuccess('Placement Copied Successfully.');
    }
    this.setState({ activeDate: dstDate.id });
  }

  _clearSelected() {
    let { vendors, placement } = this.props;
    let { selectedIndexes } = this.state;
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }
    let placementByIndex = getVendorPlacement(activeMarket, activeDate, {
      vendors,
      placement,
    });
    for (let index of selectedIndexes) {
      let existingVendor = placementByIndex[String(index)];
      if (existingVendor) {
        PlacementActions.removeVendorPlacement(
          activeMarket,
          activeDate,
          Number(index),
          existingVendor,
        );
      }
    }
  }

  _documentKeyDown(event: KeyboardEvent) {
    let activeEl = document.activeElement;
    let rootEl = toElement(ReactDOM.findDOMNode(this));
    // make sure there is either no element focused or the focus is within our component

    if (
      activeEl != null &&
      rootEl != null &&
      activeEl !== document.body &&
      !rootEl.contains(activeEl)
    ) {
      event.keyCode === KEY_ESCAPE && this._hideVendorList();
      return;
    }
    switch (event.keyCode) {
      case KEY_BACKSPACE:
      case KEY_DELETE:
        event.preventDefault();
        this._clearSelected();
        break;

      case KEY_ESCAPE:
        this._hideVendorList();
        break;

      case KEY_UP_ARROW:
        event.preventDefault();
        this._moveFocusUp();
        break;

      case KEY_DOWN_ARROW:
        event.preventDefault();
        this._moveFocusDown();
        break;

      case KEY_ENTER:
        event.preventDefault();
        this._confirmFocused();
        break;

      case KEY_SPACE:
        event.preventDefault();
        this._toggleFocused();
        break;
    }
  }

  _getNumItems() {
    let { activeMarket } = this._getActive();
    return (activeMarket && activeMarket.num_spots) || 0;
  }

  _getFocusedIndex() {
    let numItems = this._getNumItems();
    let { focusedIndex } = this.state;
    if (focusedIndex >= numItems) {
      focusedIndex = numItems === 0 ? 0 : numItems - 1;
    }
    return focusedIndex;
  }

  _moveFocusUp() {
    let { focusedIndex } = this.state;
    let newFocusedIndex = focusedIndex === 0 ? 0 : focusedIndex - 1;
    this.setState({ focusedIndex: newFocusedIndex });
  }

  _moveFocusDown() {
    let { focusedIndex } = this.state;
    let numItems = this._getNumItems();
    let maxIndex = numItems ? numItems - 1 : 0;

    focusedIndex = focusedIndex === maxIndex ? maxIndex : focusedIndex + 1;
    this.setState({ focusedIndex });
  }

  _confirmFocused() {
    let index = this._getFocusedIndex();
    let { selectedIndexes } = this.state;
    // select if not already single selected
    if (selectedIndexes.size !== 1 || !selectedIndexes.has(index)) {
      this.setState({
        selectedIndexes: new Set([index]),

        // this is used for future block (shift) selection
        selectedCursor: index,
      });
    }
  }

  _toggleFocused() {
    let index = this._getFocusedIndex();
    let { selectedIndexes } = this.state;
    // add/remove from selection
    let newSelected = new Set(selectedIndexes);
    if (selectedIndexes.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    this.setState({ selectedIndexes: newSelected });
  }
}
let styles = StyleSheet.create({
  pickerContainer: {
    flex: 1,
    flexDirection: 'row',
    zIndex: 2,
    marginBottom: 10,
  },
});

const connector = connectData()(
  () => ({
    markets: { dataStoreKey: 'markets' },
    user: { dataStoreKey: 'user' },
    vendors: { dataStoreKey: 'vendors/active' },
    placement: { dataStoreKey: 'placement' },
    positionMap: { dataStoreKey: 'position' },
  }),
  () => ({
    savePlacement: {
      dataStoreKey: 'placement',
    },
  }),
  {
    computedProps: {
      filteredMarkets: {
        props: ['markets'],
        compute: (markets: IndexedList<Market> | null | undefined) => {
          if (!markets) {
            return null;
          }
          return markets.filter(
            (market) => market.dates != null && market.dates.length !== 0,
          );
        },
      },
      sortedVendors: {
        props: ['vendors'],
        compute: (vendors: VendorList | null | undefined) => {
          return vendors ? vendors.sortByKey('name') : null;
        },
      },
    },
  },
);
type FullProps = ConnectedProps<typeof connector>;
export default connector(PlacementEditorLegacy);
